var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-whatsapp",
    transform: "translate(-4837 -645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(4837 645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    fill: "#1a1423",
    stroke: "#67e196",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 33.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(4852.693 658.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M21.067,0c8.141,0,16.294,6.682,18.117,15.859A19.792,19.792,0,0,1,25.456,38.714a19.236,19.236,0,0,1-14.578-1.352,1.025,1.025,0,0,0-.773-.08Q5.654,38.4,1.2,39.488A.87.87,0,0,1,.084,38.327q1.2-4.3,2.4-8.6a.78.78,0,0,0-.073-.638A18.436,18.436,0,0,1,.054,18.743C.715,10.46,4.937,4.655,12.564,1.371A20.187,20.187,0,0,1,21.067,0M2.127,37.461c.1-.016.145-.02.188-.03,2.553-.632,5.108-1.255,7.656-1.906a1.745,1.745,0,0,1,1.36.168,17.447,17.447,0,0,0,8.115,2.116,18.049,18.049,0,1,0-3.3-35.725A18.082,18.082,0,0,0,1.743,19.458a17.846,17.846,0,0,0,2.39,9.264,1.307,1.307,0,0,1,.133,1.088c-.584,2.036-1.149,4.077-1.72,6.117-.139.5-.273,1-.419,1.534",
    transform: "translate(0 0)",
    fill: "#67e196"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M127.038,140.494a12.607,12.607,0,0,0,6,5.324c.573.241.576.251.972-.221.375-.448.746-.9,1.1-1.363a1.584,1.584,0,0,1,2.072-.607c.955.4,1.883.86,2.824,1.294q.665.307,1.33.611a1.535,1.535,0,0,1,1.013,1.533,4.692,4.692,0,0,1-1.093,3.349,6.364,6.364,0,0,1-4.344,1.989,11.021,11.021,0,0,1-4.139-.816,20.751,20.751,0,0,1-9.593-7.188,17.346,17.346,0,0,1-2.436-3.733,7.03,7.03,0,0,1-.1-6.081,6.76,6.76,0,0,1,1.571-2.11,2.548,2.548,0,0,1,1.786-.7c.358,0,.716.009,1.074,0a1.641,1.641,0,0,1,1.5.8,7.346,7.346,0,0,1,.506,1.022c.421.985.774,2,1.255,2.957a2.424,2.424,0,0,1-.37,2.816c-.294.375-.611.732-.935,1.12m9.563,4.713c-.606.72-1.144,1.389-1.715,2.029a1.551,1.551,0,0,1-1.907.445,14.615,14.615,0,0,1-7.425-6.279,1.6,1.6,0,0,1,.229-2.143,16.158,16.158,0,0,0,1.055-1.347.468.468,0,0,0,.019-.385c-.469-1.146-.977-2.276-1.422-3.431a.822.822,0,0,0-.916-.617,1.768,1.768,0,0,0-1.359.477,4.758,4.758,0,0,0-1.119,5.151,13.271,13.271,0,0,0,2.265,3.91,19.344,19.344,0,0,0,10.493,7.41,5.322,5.322,0,0,0,3.371-.033c1.348-.516,2.385-1.319,2.445-2.919,0-.128-.052-.332-.142-.377-1.287-.645-2.584-1.268-3.869-1.892",
    transform: "translate(-111.394 -122.318)",
    fill: "#67e196"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhatsapp);
export default __webpack_public_path__ + "static/media/logo-whatsapp.32725ed17f3eea3ccad46c8f1d1f900c.svg";
export { ForwardRef as ReactComponent };